
const searchParamsHas = (key, value) => {
  let isFound = false
  const param =  new URLSearchParams(window.location.search).get(key)
  // If no value was passed, return true if key is matched
  if (!value && param) {
    isFound = true
    // If a vlue was passed, validate the found value equals the passed value
  } else if (value && param === value) {
    isFound = true
  }
  return isFound
}

export default searchParamsHas
